import { ProtocolContentData } from "../../protocol";
export default class HandOverWatch extends ProtocolContentData {
    handOverWatchTo;
    authorRole;
    oow;
    freeText;
    logReading;
    constructor(handOverWatchTo, authorRole, oow, freeText, logReading) {
        super();
        this.handOverWatchTo = handOverWatchTo;
        this.oow = oow;
        this.authorRole = authorRole;
        this.freeText = freeText;
        this.logReading = logReading;
    }
}
//# sourceMappingURL=HandOverWatch.js.map